import { useOfferEditContext } from "@/types/recruit/offer.types.ts";
import { Box, ListItem, Stack, Switch, Text, Title } from "@skailer-com/uikit";
import { useTranslation } from "react-i18next";

export const PublicLinkSection = () => {
  const { t } = useTranslation();
  const { handleUpdateConfig, offerConfig } = useOfferEditContext();

  return (
    <Stack gap={"sm"}>
      <Title size="xs" header={t("ats:share_offer")} />
      <Box variant={"border"}>
        <ListItem
          behavior={"card"}
          preTitleSlot={
            <Stack direction={"horizontal"} gap={"md"} className={"pl-0.5"}>
              <Switch
                checked={offerConfig.is_public}
                onChange={(value) => {
                  handleUpdateConfig("is_public", value);
                }}
                size="md"
              />
              <Stack>
                <Text className={"text-title"}>{t("common:create_shareable_link")} </Text>
                <Text className="text-secondary">{t("ats:shareable_link_offer_description")} </Text>
              </Stack>
            </Stack>
          }
        />
      </Box>
    </Stack>
  );
};
